import React, { useEffect, useRef, useState } from 'react';
import { sopFire } from '../../../utils/sopSwal';
import StageChrome from '../components/StageChrome';
import useGameTimer from '../components/useGameTimer';
import { ASSET, reportOnSubmit, stagecheck, submitStage } from '../../../utils/sopGame';
import '../stages.css';

const QUESTIONS = ['s3-4.png', 's3-3.png', 's3-2.png', 's3-1.png'];
const ANSWERS = ['charkha', 'khadi cloth', 'prayer and meditation', 'ahimsa hand'];
const ALTS = {
  2: ['meditation and prayer', 'meditation & prayer'],
};
const POPUPS = [
  'The spinning wheel, or charkha, is advocated for the revival of spinning and weaving as a means of economic self-sufficiency and as a symbol of self-reliance.',
  'Khadi refers to hand-spun and handwoven cloth. Wearing khadi became a symbol of support for Indian self-reliance and the movement for independence.',
  'Satyagraha emphasized the power of prayer, meditation, and self-discipline as a means of fostering inner strength and promoting nonviolent action. ',
  'It depicts an open palm with a dove in the center, representing peace and compassion',
];

function isLiveCorrect(q, val) {
  const t = val.trim().toLowerCase();
  if (t === ANSWERS[q]) return true;
  return (ALTS[q] || []).includes(t);
}

export default function Stage3({ user, onComplete, reportId, initialSeconds }) {
  const [q, setQ] = useState(0);
  const [value, setValue] = useState('');
  const [status, setStatus] = useState('');
  const [score, setScore] = useState(0);
  const [collected, setCollected] = useState([]);
  const [sending, setSending] = useState(false);
  const scored = useRef({});
  const timeeRef = useRef('00:00:00');
  const { display } = useGameTimer(initialSeconds, (hms) => {
    timeeRef.current = hms;
  });

  useEffect(() => {
    stagecheck(user).then(setScore).catch(console.error);
  }, [user]);

  const onInput = (val) => {
    setValue(val);
    if (!val.trim()) {
      setStatus('');
      return;
    }
    const ok = isLiveCorrect(q, val);
    setStatus(ok ? 'correct' : 'wrong');
    if (ok && !scored.current[q]) {
      scored.current[q] = true;
      setScore((s) => s + 1);
    }
  };

  const finishSubmit = async (answers) => {
    let points1 = 0;
    answers.forEach((a, i) => {
      if (String(a).toLowerCase() === ANSWERS[i]) points1 += 1;
    });
    setSending(true);
    try {
      await submitStage(user, {
        points: score,
        points1,
        round: 3,
        timee: timeeRef.current,
        reportId,
      });
      await reportOnSubmit(user, { points: score, timee: timeeRef.current, round: 3, reportId });
      await sopFire({ text: 'These stay symbolic with us even today! Click ok to proceed.' });
      onComplete();
    } catch (err) {
      console.error(err);
      sopFire({ text: err.message || 'Submit failed' });
      setSending(false);
    }
  };

  const next = async () => {
    if (!value.trim()) {
      sopFire({ text: 'Please provide your response in the designated text box' });
      return;
    }
    const saved = value.trim().toLowerCase();
    await sopFire({
      title: `Correct Answer is ${ANSWERS[q]}`,
      text: POPUPS[q],
    });
    const nextCollected = [...collected, saved];
    setCollected(nextCollected);
    if (q >= 3) return;
    if (q === 2) {
      setQ(3);
      setValue('');
      setStatus('');
      return;
    }
    setQ((x) => x + 1);
    setValue('');
    setStatus('');
  };

  const submit = async () => {
    if (sending) return;
    if (!value.trim()) {
      sopFire({ text: 'Please provide your response in the designated text box' });
      return;
    }
    const saved = value.trim().toLowerCase();
    const all = [...collected, saved];
    await sopFire({
      title: `Correct Answer is ${ANSWERS[q]}`,
      text: POPUPS[q],
    });
    await finishSubmit(all);
  };

  const isLast = q === 3;

  return (
    <StageChrome
      title="Satyagraha is a philosophy and practice of nonviolent resistance. Decipher a few of the symbols and actions that have become closely associated with this concept."
      score={score}
      timerDisplay={display}
    >
      <div className="sop-quiz-wrap">
        <img className="sop-quiz-image" src={ASSET.img(QUESTIONS[q])} alt="" id="imageid" />
        <input
          className={`sop-input ${status}`}
          value={value}
          placeholder="Type Here"
          readOnly={status === 'correct'}
          onChange={(e) => onInput(e.target.value)}
          autoComplete="off"
        />
      </div>
      <div className="sop-actions">
        {!isLast ? (
          <button type="button" className="sop-img-btn" onClick={next}>
            <img src={ASSET.img('next.png')} alt="Next" />
          </button>
        ) : (
          <button type="button" className="sop-img-btn" disabled={sending} onClick={submit}>
            <img src={ASSET.img('submit.png')} alt="Submit" />
          </button>
        )}
      </div>
    </StageChrome>
  );
}
